import { createContext, useContext, useState } from 'react';
import type { ReactNode } from 'react';


interface TauriTitleBarContextValue {
  isTitleBarActive: boolean;
  setTitleBarActive: (active: boolean) => void;
}

const TauriTitleBarContext = createContext<TauriTitleBarContextValue>({
  isTitleBarActive: false,
  setTitleBarActive: () => {},
});

export function TauriTitleBarProvider({ children }: { children: ReactNode }) {
  const [isTitleBarActive, setIsTitleBarActive] = useState(false);

  const setTitleBarActive = (active: boolean) => {
    setIsTitleBarActive(active);
  };

  return (
    <TauriTitleBarContext.Provider value={{ isTitleBarActive, setTitleBarActive }}>
      {children}
    </TauriTitleBarContext.Provider>
  );
}

export function useTauriTitleBar() {
  return useContext(TauriTitleBarContext);
}
